// Mirrors ServerSide/Utils/audit_log/enums.py — keep in sync via the
// /qauditmeta endpoint (FetchAuditMeta) so the UI never has to be redeployed
// when the backend adds a new event type.

export const AuditEventType = {
  USER_CREATE: "user.create",
  USER_DELETE: "user.delete",
  USER_DELETE_REQUEST: "user.delete_request",
  USER_ROLE_CHANGE: "user.role_change",
  USER_PRIV_CHANGE: "user.priv_change",
  USER_RLS_ASSIGN: "user.rls_assign",
  SECURITY_GROUP_UPDATE: "security.group_update",
  SECURITY_RLS_PROFILE_UPDATE: "security.rls_profile_update",
  SECURITY_BLS_PROFILE_UPDATE: "security.bls_profile_update",
  SECURITY_IMPERSONATION_TOGGLE: "security.impersonation_toggle",
  SECURITY_DIRECT_SIGNIN_TOGGLE: "security.direct_signin_toggle",
  SECURITY_AUTO_ASSIGNMENT_CHANGE: "security.auto_assignment_change",
  SECURITY_SSO_CONFIG_CHANGE: "security.sso_config_change",
  SECURITY_AUTHORIZATION_DENIED: "security.authorization_denied",
  SECURITY_UI_PROFILE_UPDATE: "security.ui_profile_update",
  AUTH_LOGIN_IMPERSONATION: "auth.login_impersonation",
  AUDIT_REPORT_VIEWED: "audit.report_viewed",
  AUDIT_REPORT_EXPORTED: "audit.report_exported",
  AUDIT_REPORT_EXPORTED_XLSX: "audit.report_exported_xlsx",
  AUDIT_SNAPSHOT_GENERATED: "audit.snapshot_generated"
};

export const AuditOutcome = {
  SUCCESS: "success",
  DENIED: "denied",
  FAILED: "failed"
};

export const AuditSource = {
  MANAGE_USERS_UI: "manage_users_ui",
  AUTHORIZATION_UI: "authorization_ui",
  RLS_UI: "rls_ui",
  BLS_UI: "bls_ui",
  ACCESS_GROUPS_UI: "access_groups_ui",
  UI_PROFILES_UI: "ui_profiles_ui",
  SSO_CONFIG_UI: "sso_config_ui",
  AUDIT_LOG_UI: "audit_log_ui",
  BULK_IMPORT: "bulk_import",
  API: "api",
  SYSTEM: "system",
  UNKNOWN: "unknown"
};

export const AuditReportMode = {
  LIST: "list",
  EXPORT_CSV: "export_csv",
  EXPORT_XLSX: "export_xlsx"
};

export const AUDIT_REPORT_PAGE_SIZE_DEFAULT = 100;
export const AUDIT_REPORT_PAGE_SIZE_MAX = 1000;
